import script from "./CameraOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraOverlay.vue?vue&type=script&setup=true&lang=js"

import "./CameraOverlay.vue?vue&type=style&index=0&id=4673cc36&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4673cc36"]])

export default __exports__